// extracted by mini-css-extract-plugin
module.exports = {"tool-tip-typo":"tool-tip_tool-tip-typo__spA5Z","tool-tip-wrap":"tool-tip_tool-tip-wrap__jZtm7"};